import useSessionTimer from './sessionTimer';

export const SessionTimerProvider: React.FC = () => {
  useSessionTimer();

  return null;
};
